import React from "react";
import PlanCard from "../components/PlanCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { useStepper } from "../Stepper";
import config from "config";
import Heading from "components/Heading";
import dayjs from "dayjs";
import TalkToAgentButton from "components/TalkToAgent";
import BubbleChat from "components/BubbleChat";
import SecretCard from "components/SecretCard";

//markup value only
let defaultTimePlan = null;

const Plans = () => {
  const { getDefault } = useStepper();

  if (!defaultTimePlan) {
    /*  
        adding just 10 minutes will display it as 9:59 regardless of 
        the condition so adding an extra second is neccessary. This due to the nature of 
        dayjs().diff() returning value
    */

    defaultTimePlan = dayjs(new Date())
      .add(10, "minutes")
      .add(1, "second")
      .valueOf();
  }

  return (
    <>
      <Heading
        title={
          <>
            Felicidades {getDefault("personalInfo").firstName}!
            <br />
            Usted ha sido aprobado en los siguientes planes
          </>
        }
        body={`Seleccione el plan que más se ajusta a su estrategia.`}
      />

      <Swiper
        slidesPerView={1.25}
        spaceBetween={15}
        watchSlidesProgress={true}
        longSwipesRatio={0.2}
        longSwipes
        preventClicks
        preventClicksPropagation
        slideToClickedSlide={false}
      >
        {config.plans.map((plan) => (
          <SwiperSlide key={`plan-${plan.id}`}>
            <PlanCard
              plan={plan}
              buttonText={plan.active ? "Reparar mi credito" : "Sold Out"}
              defaultTime={defaultTimePlan.valueOf()}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div style={{ paddingTop: 20 }}>
        <SecretCard {...config.secrets[3]} />
      </div>

      <BubbleChat />
    </>
  );
};

export default Plans;
